import { Reveal, SectionLabel, StaggerGroup, StaggerItem } from "@/components/Reveal";

const certs = [
  { k: "GCIH", v: "CERTIFIED_INCIDENT_HANDLER", status: "in_progress" },
  { k: "GRC_MC", v: "SIMPLY CYBER GRC MASTER CLASS · 2025" },
  { k: "FCTP_AI_NET", v: "EC-COUNCIL AI-DRIVEN NET SECURITY · UWF · 2025", url: "https://badges.parchment.com/public/assertions/JGHP7S-UTw2fQAmXYTpUwg" },
  { k: "FCTP_GRC_AI", v: "GRC IN AI · UWF · 2025", url: "https://badges.parchment.com/public/assertions/_ihvy1zaTmWImMMZtbQ7Aw" },
  { k: "PENTEST+", v: "COMPTIA_PENETRATION_TESTER", url: "https://www.credly.com/badges/73f23745-69fc-483c-988b-77ab5bd849cf" },
  { k: "CYSA+", v: "COMPTIA_CYBERSECURITY_ANALYST", url: "https://www.credly.com/badges/0f47636b-c998-4ee0-8523-d838107e8c8f" },
  { k: "SEC+", v: "COMPTIA_SECURITY+", url: "https://www.credly.com/badges/f368e1af-b096-41da-acae-9e29eca25c0c" },
  { k: "NET+", v: "COMPTIA_NETWORK+", url: "https://www.credly.com/badges/80adcdf5-b674-42ba-aa1e-86c1f1fb5659" },
  { k: "CNSP", v: "CERTIFIED_NETWORK_SECURITY_PRACTITIONER", url: "https://www.credly.com/badges/f4bf413a-e931-494a-82c1-744b384e55aa" },
  { k: "CNVP", v: "CERTIFIED_NETWORK_VULNERABILITY_PENTESTER", url: "https://www.credly.com/badges/1b536b11-a5d2-4f1c-887b-0e9dde9ee5ec" },
  { k: "CSAP", v: "CERTIFIED_SECURITY_ANALYTICS_PROFESSIONAL", url: "https://www.credly.com/badges/7e264f43-da6c-4151-8fcc-eb2cf25c800a" },
  { k: "AZ-500", v: "AZURE_SECURITY_ENGINEER_ASSOCIATE", url: "https://www.credly.com/badges/946839ac-2ea7-491f-9449-ba62b92694cf" },
  { k: "AZ-900", v: "AZURE_FUNDAMENTALS", url: "https://www.credly.com/badges/64d6f3ba-4116-4d13-a276-439f0d8021de" },
];

const marquee = [
  "NMAP",
  "METASPLOIT",
  "BURP_SUITE",
  "WIRESHARK",
  "KALI_LINUX",
  "SPLUNK",
  "AZURE_SENTINEL",
  "AZURE_DEFENDER",
  "MICROSOFT_ENTRA_ID",
  "AZURE_POLICY",
  "KEY_VAULT",
  "POWERSHELL",
  "BASH",
  "PYTHON",
  "TCP/IP",
  "MITRE_ATT&CK",
  "NIST_CSF",
  "OWASP",
  "OSINT",
  "VULN_ASSESSMENT",
];

export default function Certifications() {
  return (
    <section
      id="certifications"
      data-testid="certifications-section"
      className="relative py-24 lg:py-32 border-t border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <SectionLabel id="SYS_06">CERTIFICATIONS // CREDENTIALS</SectionLabel>

        <Reveal>
          <h2 className="font-['Unbounded'] font-bold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-[#F5F5F5] leading-[1.05] max-w-3xl">
            <span className="text-[#A1A1AA]">Paper trail,</span>
            <br />
            <span className="text-[#00FF66]">verified.</span>
          </h2>
        </Reveal>

        <StaggerGroup className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-4">
          {certs.map((c) => {
            const inProgress = c.status === "in_progress";
            const cardClass = `group relative border p-5 lg:p-6 transition-colors cursor-default ${
              inProgress
                ? "border-[#F5C518]/40 hover:border-[#F5C518] hover:bg-[#F5C518]/[0.04]"
                : "border-white/10 hover:border-[#00FF66] hover:bg-[#00FF66]/[0.03]"
            } ${c.url ? "cursor-pointer" : ""} block`;

            const inner = (
              <>
                {inProgress && (
                  <span
                    data-testid={`cert-status-${c.k.toLowerCase()}`}
                    className="absolute top-2 right-2 flex items-center gap-1.5 font-['JetBrains_Mono'] text-[8px] tracking-[0.25em] text-[#F5C518] border border-[#F5C518]/40 px-1.5 py-0.5"
                  >
                    <span className="w-1.5 h-1.5 rounded-full bg-[#F5C518] animate-pulse" />
                    IN_PROGRESS
                  </span>
                )}
                {c.url && !inProgress && (
                  <span
                    data-testid={`cert-verify-${c.k.toLowerCase()}`}
                    className="absolute top-2 right-2 font-['JetBrains_Mono'] text-[8px] tracking-[0.25em] text-[#00FF66]/70 border border-[#00FF66]/30 px-1.5 py-0.5 group-hover:text-[#00FF66] group-hover:border-[#00FF66]"
                  >
                    VERIFY ↗
                  </span>
                )}
                <div
                  className={`font-['Unbounded'] font-black text-2xl lg:text-3xl transition-colors ${
                    inProgress
                      ? "text-[#F5F5F5]/60 group-hover:text-[#F5C518]"
                      : "text-[#F5F5F5] group-hover:text-[#00FF66]"
                  }`}
                >
                  {c.k}
                </div>
                <div className="mt-3 font-['JetBrains_Mono'] text-[9px] tracking-[0.25em] text-[#A1A1AA] leading-relaxed break-words">
                  {c.v}
                </div>
              </>
            );

            return (
              <StaggerItem key={c.k}>
                {c.url ? (
                  <a
                    href={c.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`cert-${c.k.toLowerCase()}`}
                    data-status={c.status || "verified"}
                    className={cardClass}
                  >
                    {inner}
                  </a>
                ) : (
                  <div
                    data-testid={`cert-${c.k.toLowerCase()}`}
                    data-status={c.status || "verified"}
                    className={cardClass}
                  >
                    {inner}
                  </div>
                )}
              </StaggerItem>
            );
          })}
        </StaggerGroup>
      </div>

      <div className="mt-20 border-y border-white/10 overflow-hidden py-6 bg-[#080808]">
        <div className="flex whitespace-nowrap marquee-track">
          {[...marquee, ...marquee].map((m, i) => (
            <span
              key={i}
              className="font-['Unbounded'] font-black text-3xl md:text-5xl lg:text-6xl text-[#F5F5F5]/10 px-8"
            >
              {m} <span className="text-[#00FF66]/40">///</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
